package ru.arty_bikini.crm_frontend.ui.input.table

object FieldFlag {
    object Nullable
    object NotNull
    object ReadOnlyProp
    object ReadOnlyValue
    object FromGoogleForms
}